
<d-contract-edit
    v-model      = "edit"
    title        = "Wartung"
    :type-id     = "typeId"
    :contract-id = "contractId"
    :company-id  = "companyId"
    @initialized = "onInitialized"
    @saved       = "onSaved"
>
    <template v-slot:terms>
        <c-column-header
            class  = "primary mt-0"
            :label = "$t('contract.terms') "
        />

        <div class="lm-border pa-3 pt-0 mt-1">
            <c-contract-mnt-terms
                :contract   = "contract"
                :readonly   = "false"
                :unit-mode  = "false"
                :show-title = "false"
            />
        </div>
    </template>
    <template v-slot:post>
        <v-row class="no-frame pt-0">
            <f-enum-autocomplete
                v-if    = "contract"
                v-model = "contract.service"
                label   = "Service"
                module  = "msd"
                type    = "servicecompanies"
                clearable
            />
        </v-row>
        <v-row class="no-frame">
            <f-enum-autocomplete
                v-if    = "contract"
                v-model = "contract.prmRole"
                label   = "Verwalter"
                module  = "msd"
                type    = "servicecompanies"
                clearable
            />
        </v-row>
    </template>
</d-contract-edit>
